.ux-file-upload-thumbnail {
  align-items: center;
  justify-content: center;
  margin: 0 5px;
  max-height: 80px;
  max-width: 80px;

  &__inner {
    align-items: center;
    border: 1px solid $color-black;
    display: flex;
    height: 80px;
    justify-content: center;
    max-height: 80px;
    max-width: 80px;
    position: relative;
    width: 80px;

    img {
      min-height: 100%;
      object-fit: cover;
      width: 100%;
    }

    .ux-icon {
      font-size: 46px;
    }
  }

  &__name {
    display: block;
    font-size: $size-text-small;
    margin-top: 5px;
    overflow: hidden;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__delete-overlay {
    align-items: center;
    background-color: transparentize($color: #fff, $amount: 0.2);
    border: 0;
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    opacity: 0;
    outline: 0;
    position: absolute;
    right: 0;
    top: 0;
    transition: all $animationSpeed-fast $animationEasing-ease;
    width: 100%;

    .ux-icon {
      font-size: 30px;
    }

    &:hover,
    &:focus {
      cursor: pointer;
      opacity: 1;
    }
  }

  &__uploading-overlay {
    align-items: center;
    background-color: transparentize($color: #fff, $amount: 0.2);
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;

    .ux-spinner {
      position: absolute;
    }
  }
}
